module.exports = __webpack_public_path__ + "static/img/14.e2eade8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/14.png
// module id = d4hP
// module chunks = 0